// extracted by mini-css-extract-plugin
module.exports = {"central":"style_central__2gwp0","description":"style_description__3AeCq"};